var map = {
	"./img/1-detail.jpg": 806,
	"./img/2-detail.jpg": 807,
	"./img/4-detail.jpg": 808,
	"./img/6-detail.jpg": 809,
	"./img/7-detail.jpg": 810,
	"./img/Thinkpad_X1_Carbon_Premium_LCD_closeup_sh02.jpg": 811,
	"./img/Yoga_002.jpg": 812,
	"./img/about-service/img_2.jpg": 813,
	"./img/about/Izobrazhenie_3.jpg": 814,
	"./img/about/Izobrazhenie_4_2.jpg": 815,
	"./img/about/about-photo-1.jpg": 816,
	"./img/about/about-photo-2.jpg": 817,
	"./img/about/about-photo-3.jpg": 818,
	"./img/about/about-photo-4.jpg": 819,
	"./img/about/about-photo-5.jpg": 820,
	"./img/about/about-photo-6.jpg": 821,
	"./img/about/about-photo-7.jpg": 822,
	"./img/about/about-photo-8.jpg": 823,
	"./img/about/about-photo-9.jpg": 824,
	"./img/about/about-promo-bg-900-599.jpg": 825,
	"./img/about/about-promo-bg.jpg": 826,
	"./img/alfa-direkt-1.jpg": 827,
	"./img/author-1.jpg": 828,
	"./img/author-1@2x.jpg": 829,
	"./img/author-2.jpg": 830,
	"./img/author-2@2x.jpg": 831,
	"./img/author-3.jpg": 832,
	"./img/author-3@2x.jpg": 833,
	"./img/author-4.jpg": 834,
	"./img/author-4@2x.jpg": 835,
	"./img/author-5.jpg": 836,
	"./img/author-5@2x.jpg": 837,
	"./img/author-6.jpg": 838,
	"./img/author-6@2x.jpg": 839,
	"./img/bg-promo-three-mobile.jpg": 840,
	"./img/bg-promo-three-mobile@2x.jpg": 841,
	"./img/bg-promo-three.jpg": 842,
	"./img/bg-promo-three@2x.jpg": 843,
	"./img/bill/product-detail-marketing-promo-bg-mobile.jpg": 520,
	"./img/bill/product-detail-marketing-promo-bg.jpg": 519,
	"./img/bittner-pharma-1.jpg": 844,
	"./img/brochure-promo-bg.jpg": 845,
	"./img/brochure/avatar-1.jpg": 846,
	"./img/brochure/avatar-2.jpg": 847,
	"./img/brochure/avatar-3.jpg": 848,
	"./img/brochure/avatar-4.jpg": 849,
	"./img/brochure/avatar-5.jpg": 850,
	"./img/brochure/brochure-promo-bg.jpg": 851,
	"./img/categories/skin-1.jpg": 595,
	"./img/categories/skin-2.jpg": 594,
	"./img/categories/skin-4.jpg": 598,
	"./img/categories/skin-5.jpg": 600,
	"./img/categories/skin-6.jpg": 602,
	"./img/categories/skin-7.jpg": 603,
	"./img/categories/skin-8.jpg": 591,
	"./img/choose-platform/brochure-promo-bg.jpg": 852,
	"./img/clients-items/alfa_bank/alfa-bank-1.jpg": 552,
	"./img/clients-items/amplua_broker/amplua-broker-bg.jpg": 553,
	"./img/clients-items/bittner_farma/bittner-farma-1.jpg": 554,
	"./img/clients-items/completo/completo-bg.jpg": 555,
	"./img/clients-items/completo/completo-review-avatar.jpg": 467,
	"./img/clients-items/faberlic/faberlic-bg.jpg": 557,
	"./img/clients-items/fokus_media/fokus-media-1.jpg": 853,
	"./img/clients-items/foodik/foodik-bg.jpg": 558,
	"./img/clients-items/ilearney/ilearney-1.jpg": 854,
	"./img/clients-items/lenovo/lenovo-bg-content-3.jpg": 855,
	"./img/clients-items/lenovo/lenovo-bg.jpg": 856,
	"./img/clients-items/lenovo/lenovo-review-avatar.jpg": 857,
	"./img/clients-items/mgu/mgu-1.jpg": 561,
	"./img/clients-items/mgu/mgu-bg.jpg": 559,
	"./img/clients-items/mgu/mgu-review-avatar.jpg": 487,
	"./img/clients-items/mgu/mgu-video-poster.jpg": 560,
	"./img/clients-items/midea/midea-1.jpg": 563,
	"./img/clients-items/midea/midea-bg.jpg": 562,
	"./img/clients-items/qiwi/qiwi-bg.jpg": 858,
	"./img/clients-items/review-bg.jpg": 483,
	"./img/clients-items/rudn/rudn-1.jpg": 564,
	"./img/clients-items/see-also/fokus-media-skin.jpg": 481,
	"./img/clients-items/see-also/ilearney-logo.jpg": 490,
	"./img/clients-items/see-also/ilearney-skin.jpg": 489,
	"./img/clients-items/see-also/lenovo-skin.jpg": 482,
	"./img/clients-items/see-also/rudn-skin.jpg": 859,
	"./img/clients-items/siemens/siemens-bg.jpg": 565,
	"./img/completo/skin-detail-completo-promo.jpg": 860,
	"./img/completo/skin-detail-completo-review-avatar.jpg": 861,
	"./img/completo/skin-detail-completo-video-poster.jpg": 556,
	"./img/completo/skin-detail-msu-video-poster.jpg": 862,
	"./img/contacts/contacts--promo.jpg": 586,
	"./img/contacts/contacts-photo.jpg": 863,
	"./img/contacts/product-detail-promo-bg.jpg": 864,
	"./img/content-page-promo-bg.jpg": 468,
	"./img/content/content-page-promo-bg.jpg": 865,
	"./img/content/content-photo.jpg": 866,
	"./img/control-1-760.jpg": 867,
	"./img/control-1.jpg": 868,
	"./img/control-1@2x.jpg": 869,
	"./img/control-3-760.jpg": 870,
	"./img/control-3.jpg": 871,
	"./img/control-3@2x.jpg": 872,
	"./img/control-4-760.jpg": 873,
	"./img/control-4.jpg": 874,
	"./img/control-4@2x.jpg": 875,
	"./img/director-speech/director-speech-bg.jpg": 876,
	"./img/efficiency-mark-2.jpg": 877,
	"./img/efficiency-mark-2@2x.jpg": 878,
	"./img/faq_and_support/support.jpg": 587,
	"./img/faq_and_support/support_2x.jpg": 879,
	"./img/forum-madia-1.jpg": 880,
	"./img/functions/for-learning/data-handling-screen-1.jpg": 881,
	"./img/functions/for-learning/data-handling-screen-2.jpg": 882,
	"./img/functions/for-learning/easy-learn-photo.jpg": 883,
	"./img/functions/for-learning/fast-start-photo.jpg": 884,
	"./img/functions/for-learning/planning-screen.jpg": 885,
	"./img/functions/for-learning/product-detail-promo-bg.jpg": 886,
	"./img/functions/for-marketing/landings-bg.jpg": 887,
	"./img/functions/for-marketing/landings-screen-2.jpg": 888,
	"./img/functions/for-marketing/landings.jpg": 889,
	"./img/functions/for-marketing/payments-screen-12.jpg": 890,
	"./img/functions/for-marketing/payments-screen-13.jpg": 891,
	"./img/functions/for-marketing/product-detail-marketing-promo-bg.jpg": 567,
	"./img/functions/for-marketing/statistic-screen-1.jpg": 892,
	"./img/functions/for-marketing/statistic-screen-2.jpg": 893,
	"./img/functions/for-marketing/video-editor-bg.jpg": 894,
	"./img/functions/for-meetings/product-detail-meeting-promo-bg.jpg": 895,
	"./img/functions/for-meetings/statistic-screen-3.jpg": 896,
	"./img/functions/for-meetings/statistic-screen-4.jpg": 897,
	"./img/functions/for-meetings/statistic-screen-5.jpg": 898,
	"./img/functions/product-detail-broadcasting-bg.jpg": 550,
	"./img/functions/product-detail-promo-bg-900-591.jpg": 617,
	"./img/functions/product-detail-promo-bg.jpg": 486,
	"./img/gos-bg-mobile.jpg": 899,
	"./img/gos-bg.jpg": 900,
	"./img/ilearney-1.jpg": 901,
	"./img/industry-healthcare/form-image.jpg": 902,
	"./img/industry-healthcare/image.jpg": 903,
	"./img/industry-healthcare/image_mobile.jpg": 904,
	"./img/industry-healthcare/promo.jpg": 905,
	"./img/industry-healthcare/promo_mobile.jpg": 906,
	"./img/industry-healthcare/promo_tablet.jpg": 907,
	"./img/interface/apple.jpg": 908,
	"./img/interface/interface-screen-1.jpg": 909,
	"./img/interface/interface-screen-10.jpg": 910,
	"./img/interface/interface-screen-11.jpg": 911,
	"./img/interface/interface-screen-12.jpg": 912,
	"./img/interface/interface-screen-13.jpg": 913,
	"./img/interface/interface-screen-14.jpg": 914,
	"./img/interface/interface-screen-2.jpg": 915,
	"./img/interface/interface-screen-3.jpg": 916,
	"./img/interface/interface-screen-4.jpg": 917,
	"./img/interface/interface-screen-5.jpg": 588,
	"./img/interface/interface-screen-6.jpg": 589,
	"./img/interface/interface-screen-7.jpg": 590,
	"./img/interface/interface-screen-8.jpg": 918,
	"./img/interface/interface-screen-9.jpg": 919,
	"./img/logo-ilearney.jpg": 920,
	"./img/logo/UhMbtVsiemens2.jpg": 921,
	"./img/logo/amplua.jpg": 922,
	"./img/logo/completo.jpg": 923,
	"./img/logo/faberlic.jpg": 924,
	"./img/logo/it_2.jpg": 925,
	"./img/logo/logo-amplua.jpg": 601,
	"./img/logo/logo-bittner-farma.jpg": 596,
	"./img/logo/logo-completo.jpg": 604,
	"./img/logo/logo-faberlic.jpg": 597,
	"./img/logo/logo-ilearney.jpg": 599,
	"./img/logo/logo-platezhnye-sistemy-qiwi.jpg": 926,
	"./img/logo/logo-qiwi.jpg": 592,
	"./img/logo/logo-siemens.jpg": 593,
	"./img/main/main--products/task-management.jpg": 927,
	"./img/main/main--reviews/reviews-author-1.jpg": 928,
	"./img/main/main--reviews/reviews-author-2.jpg": 929,
	"./img/main/main--reviews/reviews-author-3.jpg": 930,
	"./img/meetings-skype/author-review.jpg": 931,
	"./img/meetings-zoom/author-review.jpg": 932,
	"./img/midea-bg.jpg": 933,
	"./img/midea-img1.jpg": 934,
	"./img/multilingualism.jpg": 935,
	"./img/multilingualism@2x.jpg": 936,
	"./img/online-learning-1.jpg": 937,
	"./img/online-learning-1@2x.jpg": 938,
	"./img/online-learning-3.jpg": 939,
	"./img/online-learning-3@2x.jpg": 940,
	"./img/online-learning-4.jpg": 941,
	"./img/online-learning-4@2x.jpg": 942,
	"./img/paralax-content-mobile.jpg": 943,
	"./img/paralax-content.jpg": 944,
	"./img/partners-bg.jpg": 945,
	"./img/partners/contacts_mobile.jpg": 616,
	"./img/partners/contacts_tablet.jpg": 614,
	"./img/partners/promo_desktop.jpg": 613,
	"./img/partners/promo_mobile.jpg": 615,
	"./img/personaldemo/event-1.jpg": 946,
	"./img/platform.jpg": 947,
	"./img/platform/platform.jpg": 948,
	"./img/platform/platform@2x.jpg": 949,
	"./img/platform@2x.jpg": 950,
	"./img/price.jpg": 951,
	"./img/product-detail-promo-bg.jpg": 952,
	"./img/product-detail/product-detail-marketing-promo-bg.jpg": 953,
	"./img/product-detail/product-detail-promo-bg.jpg": 954,
	"./img/products-comdi/capability-img_1.jpg": 729,
	"./img/products-comdi/capability-img_2.jpg": 730,
	"./img/products-comdi/capability-img_3.jpg": 731,
	"./img/products-comdi/capability-slider-img_1--mobile.jpg": 618,
	"./img/products-comdi/capability-slider-img_1.jpg": 732,
	"./img/products-comdi/capability-slider-img_2--mobile.jpg": 619,
	"./img/products-comdi/capability-slider-img_2.jpg": 733,
	"./img/products-comdi/capability-slider-img_3--mobile.jpg": 620,
	"./img/products-comdi/capability-slider-img_3.jpg": 734,
	"./img/products-comdi/form-img.jpg": 621,
	"./img/products-comdi/img_bg.jpg": 540,
	"./img/products-comdi/organization-img_2--mobile.jpg": 622,
	"./img/products-comdi/organization-img_2--tablet.jpg": 735,
	"./img/products-comdi/organization-img_2.jpg": 736,
	"./img/products-meetings/meetings--detail/1.jpg": 955,
	"./img/products-meetings/meetings--detail/2.jpg": 956,
	"./img/products-meetings/meetings--detail/3.jpg": 957,
	"./img/products-meetings/meetings--detail/4.jpg": 958,
	"./img/products-meetings/meetings--exp/anatoly_volkov.jpg": 737,
	"./img/products-meetings/meetings--exp/andrey_zhirkov.jpg": 738,
	"./img/products-meetings/meetings--exp/dmitry_starostov.jpg": 739,
	"./img/products-meetings/meetings--exp/reviews/author-1.jpg": 740,
	"./img/products-meetings/meetings--exp/reviews/author-2.jpg": 741,
	"./img/products-meetings/meetings--exp/reviews/author-3.jpg": 742,
	"./img/products-meetings/meetings--expand/boards.jpg": 623,
	"./img/products-meetings/meetings--form/form.jpg": 743,
	"./img/products-meetings/meetings--form/form_768.jpg": 744,
	"./img/products-meetings/meetings--form/form_992.jpg": 745,
	"./img/products-meetings/meetings--high-level/ai.jpg": 624,
	"./img/products-meetings/meetings--high-level/platform.jpg": 625,
	"./img/products-meetings/meetings--high-level/slider/1.jpg": 746,
	"./img/products-meetings/meetings--high-level/slider/2.jpg": 747,
	"./img/products-meetings/meetings--high-level/slider/3.jpg": 748,
	"./img/products-meetings/meetings--high-level/slider/4.jpg": 749,
	"./img/products-meetings/meetings--request-rooms/rooms_1.jpg": 959,
	"./img/products-meetings/meetings--request-rooms/rooms_2.jpg": 960,
	"./img/products-meetings/meetings--request-rooms/rooms_3.jpg": 961,
	"./img/products-meetings/meetings--request-rooms/rooms_4.jpg": 962,
	"./img/products-meetings/meetings--tariffs/tariff.jpg": 626,
	"./img/products-meetings/meetings--tariffs/tariff_375.jpg": 750,
	"./img/products-meetings/meetings--top/1440_top.jpg": 751,
	"./img/products-meetings/meetings--top/375_top.jpg": 752,
	"./img/products-meetings/meetings--top/768_top.jpg": 753,
	"./img/products-messenger/cases/author_chernogolovka.jpg": 754,
	"./img/products-messenger/cases/author_kantiana.jpg": 755,
	"./img/products-messenger/tariffs_card_1.jpg": 627,
	"./img/products-messenger/tariffs_card_2.jpg": 628,
	"./img/products-messenger/tariffs_card_2_mobile.jpg": 756,
	"./img/products-on-premise/case-1-mobile.jpg": 629,
	"./img/products-on-premise/case-1-tablet.jpg": 630,
	"./img/products-on-premise/case-1.jpg": 631,
	"./img/products-on-premise/image_1.jpg": 632,
	"./img/products-on-premise/image_1_mobile.jpg": 633,
	"./img/products-on-premise/image_1_tablet.jpg": 634,
	"./img/products-on-premise/image_3.jpg": 635,
	"./img/products-on-premise/slide_control.jpg": 636,
	"./img/products-on-premise/slide_groups.jpg": 637,
	"./img/products-on-premise/slide_logging.jpg": 638,
	"./img/products-on-premise/slide_waiting-room.jpg": 639,
	"./img/products-rooms/for_who_1.jpg": 640,
	"./img/products-rooms/for_who_1_mobile.jpg": 641,
	"./img/products-rooms/for_who_1_tablet.jpg": 642,
	"./img/products-rooms/for_who_2.jpg": 643,
	"./img/products-rooms/for_who_2_mobile.jpg": 644,
	"./img/products-rooms/for_who_2_tablet.jpg": 645,
	"./img/products-rooms/for_who_3.jpg": 646,
	"./img/products-rooms/for_who_3_mobile.jpg": 647,
	"./img/products-rooms/for_who_3_tablet.jpg": 648,
	"./img/products-rooms/image_2.jpg": 649,
	"./img/products-rooms/image_2_mobile.jpg": 650,
	"./img/products-rooms/image_2_tablet.jpg": 651,
	"./img/products-rooms/image_3.jpg": 652,
	"./img/products-rooms/image_3_mobile.jpg": 653,
	"./img/products-rooms/image_3_tablet.jpg": 654,
	"./img/products-rooms/image_4.jpg": 655,
	"./img/products-rooms/photo_1.jpg": 656,
	"./img/products-rooms/photo_2.jpg": 657,
	"./img/products-rooms/photo_3.jpg": 658,
	"./img/products-rooms/photo_4.jpg": 659,
	"./img/products-rooms/video.jpg": 963,
	"./img/products-task-management/task-management--advantages/card-bg.jpg": 757,
	"./img/products-task-management/task-management--details/convenient-tool.jpg": 964,
	"./img/products-task-management/task-management--details/quick-search.jpg": 965,
	"./img/products-task-management/task-management--details/single-space.jpg": 966,
	"./img/products-task-management/task-management--details/time-saving.jpg": 967,
	"./img/products-task-management/task-management--form/form-bg--767.jpg": 660,
	"./img/products-task-management/task-management--form/form-bg--991.jpg": 661,
	"./img/products-task-management/task-management--form/form-bg.jpg": 758,
	"./img/products-task-management/task-management--promo/promo-bg--375.jpg": 662,
	"./img/products-task-management/task-management--promo/promo-bg--767.jpg": 663,
	"./img/products-task-management/task-management--promo/promo-bg.jpg": 759,
	"./img/products-webinars/cases/cases-author-1.jpg": 968,
	"./img/products-webinars/cases/cases-author-2.jpg": 969,
	"./img/products-webinars/cases/cases-author-3.jpg": 970,
	"./img/products-webinars/cases/cases-author-4.jpg": 971,
	"./img/products-webinars/cases/cases-author-5.jpg": 972,
	"./img/products-webinars/cases/cases-author-6.jpg": 973,
	"./img/products-webinars/cases/cases-logo-1.jpg": 974,
	"./img/products-webinars/cases/cases-logo-2.jpg": 975,
	"./img/products-webinars/cases/cases-logo-3.jpg": 976,
	"./img/products-webinars/cases/cases-logo-4.jpg": 977,
	"./img/products-webinars/cases/cases-logo-5.jpg": 978,
	"./img/products-webinars/cases/cases-logo-6.jpg": 979,
	"./img/products-webinars/devices_1_1920.jpg": 980,
	"./img/products-webinars/devices_1_375.jpg": 981,
	"./img/products-webinars/devices_1_768.jpg": 982,
	"./img/products-webinars/devices_2_1920.jpg": 983,
	"./img/products-webinars/devices_2_375.jpg": 984,
	"./img/products-webinars/devices_2_768.jpg": 985,
	"./img/products-webinars/link-on-premise-bg_1920.jpg": 986,
	"./img/products-webinars/link-on-premise-bg_375.jpg": 987,
	"./img/products-webinars/link-on-premise-bg_768.jpg": 988,
	"./img/products-webinars/webinars--exp/reviews/author-1.jpg": 989,
	"./img/products-webinars/webinars--exp/reviews/author-2.jpg": 990,
	"./img/products-webinars/webinars--exp/reviews/author-3.jpg": 991,
	"./img/products-webinars/webinars--expand/1440 kurs.jpg": 664,
	"./img/products-webinars/webinars--form/man--1199.jpg": 665,
	"./img/products-webinars/webinars--form/man--1320.jpg": 760,
	"./img/products-webinars/webinars--form/man--1920.jpg": 761,
	"./img/products-webinars/webinars--form/man--375.jpg": 666,
	"./img/products-webinars/webinars--form/man--580.jpg": 762,
	"./img/products-webinars/webinars--form/man--768.jpg": 763,
	"./img/products-webinars/webinars--form/man--980.jpg": 764,
	"./img/products-webinars/webinars--media/1.jpg": 992,
	"./img/products-webinars/webinars--tariffs/1440_tarif.jpg": 765,
	"./img/products-webinars/webinars--tariffs/375 tarif.jpg": 766,
	"./img/products-webinars/webinars--tariffs/768_tarif.jpg": 767,
	"./img/products-webinars/webinars--top/1440_top.jpg": 768,
	"./img/products-webinars/webinars--top/768_top.jpg": 769,
	"./img/products-webinars/webinars-form__1920.jpg": 993,
	"./img/products-webinars/webinars_1_1920.jpg": 994,
	"./img/products-webinars/webinars_1_375.jpg": 995,
	"./img/products-webinars/webinars_1_768.jpg": 996,
	"./img/products-webinars/webinars_2_1920.jpg": 997,
	"./img/products-webinars/webinars_2_375.jpg": 998,
	"./img/products-webinars/webinars_3_1920.jpg": 999,
	"./img/products-webinars/webinars_3_375.jpg": 1000,
	"./img/products-webinars/webinars_6_1920.jpg": 1001,
	"./img/products-webinars/webinars_6_375.jpg": 1002,
	"./img/products-webinars/webinars_7_1920.jpg": 1003,
	"./img/products-webinars/webinars_7_375.jpg": 1004,
	"./img/products-webinars/webinars_7_768.jpg": 1005,
	"./img/registration-1.jpg": 1006,
	"./img/registration-1@2x.jpg": 1007,
	"./img/registration-2.jpg": 1008,
	"./img/registration-2@2x.jpg": 1009,
	"./img/registration-3-test.jpg": 1010,
	"./img/registration-3.jpg": 1011,
	"./img/registration-3@2x.jpg": 1012,
	"./img/registration-4.jpg": 1013,
	"./img/registration-4@2x.jpg": 1014,
	"./img/registration-5.jpg": 1015,
	"./img/registration-5@2x.jpg": 1016,
	"./img/registration-6.jpg": 1017,
	"./img/registration-6@2x.jpg": 1018,
	"./img/reviews-author-11.jpg": 1019,
	"./img/reviews-author-11@2x.jpg": 1020,
	"./img/reviews-author-12.jpg": 1021,
	"./img/reviews-author-12@2x.jpg": 1022,
	"./img/reviews-author-13.jpg": 1023,
	"./img/reviews-author-13@2x.jpg": 1024,
	"./img/reviews-author-14.jpg": 1025,
	"./img/reviews-author-14@2x.jpg": 1026,
	"./img/reviews-author-15.jpg": 1027,
	"./img/reviews-author-16.jpg": 1028,
	"./img/reviews-author-17.jpg": 1029,
	"./img/reviews/review-photo-1.jpg": 551,
	"./img/reviews/review-photo-2.jpg": 1030,
	"./img/rudn-1.jpg": 1031,
	"./img/signup/signup-background.jpg": 229,
	"./img/skin-detail-completo-promo.jpg": 1032,
	"./img/skin-detail-completo-review-avatar.jpg": 1033,
	"./img/skin-detail-completo-video-poster.jpg": 1034,
	"./img/skin-detail-msu-review-avatar.jpg": 1035,
	"./img/skin-detail-msu-spec-block.jpg": 1036,
	"./img/skin-detail-msu-video-poster.jpg": 1037,
	"./img/skin-detail-promo-msu.jpg": 1038,
	"./img/skin-detail-review-bg.jpg": 1039,
	"./img/skin-detail-use-functions-bg.jpg": 1040,
	"./img/skin-fokus-media.jpg": 1041,
	"./img/skin-ilearney.jpg": 1042,
	"./img/skin-rudn.jpg": 1043,
	"./img/support-promo-bg-900-599.jpg": 612,
	"./img/support-promo-bg.jpg": 611,
	"./img/tariffs/product-detail-promo-bg.jpg": 541,
	"./img/task/common-healthcare/background_gradient.jpg": 484,
	"./img/task/common-healthcare/background_gradient_mobile.jpg": 1044,
	"./img/task/common-healthcare/background_violet.jpg": 526,
	"./img/task/common-healthcare/form_image.jpg": 485,
	"./img/task/common-healthcare/form_image_mobile.jpg": 511,
	"./img/task/common-healthcare/form_image_tablet.jpg": 512,
	"./img/task/common-healthcare/image_1.jpg": 527,
	"./img/task/common-healthcare/image_1_mobile.jpg": 528,
	"./img/task/common-healthcare/image_2.jpg": 542,
	"./img/task/common-healthcare/image_2_mobile.jpg": 543,
	"./img/task/common-healthcare/image_3.jpg": 667,
	"./img/task/common-healthcare/image_3_mobile.jpg": 668,
	"./img/task/common-healthcare/image_4.jpg": 544,
	"./img/task/common-healthcare/image_4_mobile.jpg": 545,
	"./img/task/common-healthcare/image_5.jpg": 669,
	"./img/task/common-healthcare/image_5_mobile.jpg": 670,
	"./img/task/common-healthcare/image_5_tablet.jpg": 671,
	"./img/task/common-healthcare/image_6.jpg": 672,
	"./img/task/common-healthcare/image_6_mobile.jpg": 673,
	"./img/task/common-healthcare/image_6_tablet.jpg": 674,
	"./img/task/common-healthcare/image_7.jpg": 675,
	"./img/task/common-healthcare/image_7_mobile.jpg": 676,
	"./img/task/common-healthcare/image_7_tablet.jpg": 677,
	"./img/task/common-healthcare/image_8.jpg": 546,
	"./img/task/common-healthcare/image_8_mobile.jpg": 547,
	"./img/task/education/devices_2_1920.jpg": 568,
	"./img/task/education/devices_2_375.jpg": 678,
	"./img/task/education/devices_2_768.jpg": 569,
	"./img/task/education/devices_3_1920.jpg": 570,
	"./img/task/education/devices_3_375.jpg": 679,
	"./img/task/education/devices_3_768.jpg": 571,
	"./img/task/education/form_1920.jpg": 532,
	"./img/task/education/tools_chats_1920.jpg": 572,
	"./img/task/education/tools_chats_768.jpg": 573,
	"./img/task/education/tools_meetings_1920.jpg": 574,
	"./img/task/education/tools_meetings_768.jpg": 575,
	"./img/task/education/who-is-suitable_1_1920.jpg": 576,
	"./img/task/education/who-is-suitable_2_1920.jpg": 577,
	"./img/task/education/who-is-suitable_3_1920.jpg": 578,
	"./img/task/healthcare/form-image.jpg": 548,
	"./img/task/healthcare/image.jpg": 680,
	"./img/task/healthcare/image_mobile.jpg": 681,
	"./img/task/healthcare/image_tablet.jpg": 682,
	"./img/task/healthcare/promo.jpg": 683,
	"./img/task/healthcare/promo_mobile.jpg": 684,
	"./img/task/healthcare/promo_tablet.jpg": 685,
	"./img/task/med/alternate_1.jpg": 686,
	"./img/task/med/alternate_1_mobile.jpg": 579,
	"./img/task/med/alternate_1_tablet.jpg": 687,
	"./img/task/med/alternate_2.jpg": 688,
	"./img/task/med/alternate_2_mobile.jpg": 580,
	"./img/task/med/alternate_2_tablet.jpg": 689,
	"./img/task/med/alternate_3.jpg": 690,
	"./img/task/med/alternate_3_mobile.jpg": 581,
	"./img/task/med/alternate_3_tablet.jpg": 691,
	"./img/task/med/promo.jpg": 692,
	"./img/task/med/promo_mobile.jpg": 693,
	"./img/task/nmo/image_1.jpg": 694,
	"./img/task/nmo/image_1_mobile.jpg": 695,
	"./img/task/nmo/image_3.jpg": 549,
	"./img/task/nmo/promo.jpg": 696,
	"./img/task/nmo/promo_mobile.jpg": 697,
	"./img/task/nmo/promo_tablet.jpg": 1045,
	"./img/task/ouz/image_1.jpg": 698,
	"./img/task/ouz/image_2.jpg": 699,
	"./img/task/ouz/image_3.jpg": 700,
	"./img/task/ouz/image_4.jpg": 701,
	"./img/task/ouz/image_5.jpg": 702,
	"./img/task/ouz/image_6.jpg": 703,
	"./img/task/ouz/image_6_mobile.jpg": 704,
	"./img/task/ouz/image_6_tablet.jpg": 705,
	"./img/task/ouz/promo.jpg": 706,
	"./img/task/ouz/promo_mobile.jpg": 707,
	"./img/task/pharma/image_1.jpg": 708,
	"./img/task/pharma/image_1_mobile.jpg": 709,
	"./img/task/pharma/image_2.jpg": 710,
	"./img/task/pharma/image_2_tablet.jpg": 711,
	"./img/task/pharma/image_3.jpg": 712,
	"./img/task/pharma/image_4.jpg": 713,
	"./img/task/pharma/image_5.jpg": 714,
	"./img/task/pharma/image_6.jpg": 715,
	"./img/task/pharma/image_6_mobile.jpg": 716,
	"./img/task/pharma/promo.jpg": 717,
	"./img/task/pharma/promo_mobile.jpg": 718,
	"./img/task/pharma/promo_tablet.jpg": 719,
	"./img/why-choose/why-choose-bg-900-735.jpg": 1046,
	"./img/why-choose/why-choose-bg.jpg": 1047,
	"./img/yaroslav_feshin.jpg": 1048,
	"./new-design/img/products/common/additional-products/boards.jpg": 2221,
	"./new-design/img/products/westudy/advantages/advantages-bg--375.jpg": 2157,
	"./new-design/img/products/westudy/advantages/advantages-bg--767.jpg": 2158,
	"./new-design/img/products/westudy/advantages/advantages-bg--991.jpg": 2159,
	"./new-design/img/products/westudy/advantages/advantages-bg.jpg": 2222,
	"./new-design/img/products/westudy/feature-preview/certificates.jpg": 2327,
	"./new-design/img/products/westudy/feature-preview/course-editor.jpg": 2328,
	"./new-design/img/products/westudy/feature-preview/learning-analytics.jpg": 2329,
	"./new-design/img/products/westudy/feature-preview/lesson-formats.jpg": 2330,
	"./new-design/img/products/westudy/feature-preview/mixed-learning.jpg": 2331,
	"./new-design/img/products/westudy/feature-preview/news-feed.jpg": 2332,
	"./new-design/img/products/westudy/feature-preview/paid-learning.jpg": 2333,
	"./new-design/img/products/westudy/feature-preview/scorm-courses.jpg": 2334,
	"./new-design/img/products/westudy/feature-preview/tests-and-surveys.jpg": 2335,
	"./new-design/img/products/westudy/form/form-bg--767.jpg": 2160,
	"./new-design/img/products/westudy/form/form-bg--991.jpg": 2161,
	"./new-design/img/products/westudy/form/form-bg.jpg": 2223,
	"./new-design/img/products/westudy/promo/promo-bg--579.jpg": 2224,
	"./new-design/img/products/westudy/promo/promo-bg--767.jpg": 2225,
	"./new-design/img/products/westudy/promo/promo-bg--991.jpg": 2226,
	"./new-design/img/products/westudy/promo/promo-bg.jpg": 2336,
	"./new-design/img/products/westudy/tariffs/tariff-selection-bg--1199.jpg": 2227,
	"./new-design/img/products/westudy/tariffs/tariff-selection-bg--375.jpg": 2228,
	"./new-design/img/products/westudy/tariffs/tariff-selection-bg--767.jpg": 2229,
	"./new-design/img/products/westudy/tariffs/tariff-selection-bg--991.jpg": 2230,
	"./new-design/img/products/westudy/tariffs/tariff-selection-bg.jpg": 2337,
	"./new-design/img/reviews/ego-university.jpg": 2231,
	"./new-design/img/reviews/kladovaya-zdorovya.jpg": 2232,
	"./new-design/img/reviews/sodeystvie.jpg": 2233,
	"./new-design/img/reviews/tek-torg.jpg": 2234,
	"./video/video-poster.jpg": 2338
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 771;